import { RespondentModel } from "../RespondentModel";

export const getCoordinates = (respondent: RespondentModel): string => {
    return (
        (respondent?.latitude &&
            respondent?.longitude &&
            `${respondent.latitude}, ${respondent.longitude}`) ||
        ""
    );
};
